import React from 'react'

import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Crawler from '../pages/Crawler'
import Affiliates from '../pages/Affiliates'
import CreditVerification from '../pages/CreditVerification'
import Documents from '../pages/Documents'
import PasswordReset from '../pages/PasswordReset'
import Share from '../pages/Share'
import ThirdPart from '../pages/ThirdPart'
import DeepLink from '../pages/DeepLink'
import ContractCreation from '../pages/ContractCreation'
import OLXOAuth from '../pages/OLXOAuth'

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path='/landlord'>
          <Crawler />
        </Route>
        <Route path='/affiliates'>
          <Affiliates />
        </Route>
        <Route path='/documents'>
          <Documents />
        </Route>
        <Route path='/password-reset/:token'>
          <PasswordReset />
        </Route>
        <Route path='/contract'>
          <ContractCreation />
        </Route>
        <Route path='/share'>
          <Share />
        </Route>
        <Route path='/third-part'>
          <ThirdPart />
        </Route>
        <Route path='/credit'>
          <CreditVerification />
        </Route>
        <Route path='/deeplink'>
          <DeepLink />
        </Route>
        <Route path='/olx-auth'>
          <OLXOAuth />
        </Route>
      </Switch>
    </BrowserRouter>
  )
}

export default Router
